// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3OyPa","title":"Info_title__17FCu","selects":"Info_selects__kjMGT","requiredAsterisk":"Info_requiredAsterisk__2i-tS"};